import React, { useState, useEffect } from 'react'
import './Navbar.css'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../api/Authcontext'
import { IoHomeOutline, IoNewspaperOutline, IoPersonCircleOutline,IoPeopleOutline } from "react-icons/io5";
import { FaRegCreditCard, FaBuildingColumns } from "react-icons/fa6";
import { FaHandHoldingUsd } from "react-icons/fa";
import logo from '../assets/logo.png'
import Separator from './UI/Separator';
import { GrMoney } from "react-icons/gr";

const Navbar = ({ className, isMobileMenuOpen, onClose }) => {
    const location = useLocation();
    const { userData } = useAuth();
    const [navItems, setnavItems] = useState([])
    
    const userNavItems = [
        { name: 'Home', icon: <IoHomeOutline size={24}/>, link: '/home' },
        { name: 'Legacy Credits', icon: <FaRegCreditCard size={24}/>, link: '/user-legacy-credits' },
        { name: 'Loans', icon: <FaHandHoldingUsd size={24}/>, link: '/user-loans'},
        { name: 'Notices', icon: <IoNewspaperOutline size={24}/>, link: '/notices' },
        { name: 'Departments', icon: <FaBuildingColumns size={24}/>, link: '/departments' },
        { name: 'Investments', icon: <GrMoney size={24}/>, link: '/investments' },
    ];

    const adminNavItems = [
        { name: 'Home', icon: <IoHomeOutline size={24}/>, link: '/home' },
        { name: 'Legacy Credits', icon: <FaRegCreditCard size={24}/>, link: '/admin-legacy-credits' },
        { name: 'Loans', icon: <FaHandHoldingUsd size={24}/>, link: '/admin-loans'},
        { name: 'Users', icon: <IoPeopleOutline size={24}/>, link: '/users' },
        { name: 'Notices', icon: <IoNewspaperOutline size={24}/>, link: '/notices' },
        { name: 'Departments', icon: <FaBuildingColumns size={24}/>, link: '/departments' },
        { name: 'Investments', icon: <GrMoney size={24}/>, link: '/investments' },
    ];

    useEffect(() => {
        if (userData?.role === 'admin') {
            setnavItems(adminNavItems);
        } else {
            setnavItems(userNavItems);
        }
    }, [userData]);

    const NavItem = ({ name, icon, link }) => (
        <Link to={link} className="nav-link" onClick={onClose}>
            <div className="nav-icon">{icon}</div>
            <div className="nav-name">{name}</div>
        </Link>
    );

    // Get user details from authenticated user data
    const details = {
        name: userData?.name || 'User',
        email: userData?.email || 'user@example.com'
    }

    const initials = details.name.split(' ').slice(0, 2).map(n => n[0]).join('');

    const navbarClasses = `navbar ${className || ''} ${isMobileMenuOpen ? 'mobile-open' : ''}`.trim();

    return (
        <div className={navbarClasses}>

            <img src={logo} alt="Logo" className="nav-logo" />
            <h5>RENJIT WELFARE</h5>

            <div className='nav-profile'>
                <div className="user-initials">
                    <span>{initials}</span>
                </div>
                <div className="user-info">
                    <span className="user-name">{details.name.toUpperCase()}</span>
                    <span className="user-email">{details.email}</span>
                </div>
            </div>

            {navItems.map((item, index) => {
                const isActive = location.pathname === item.link;
                return (
                    <div key={index} className={`nav-item ${isActive ? 'active' : ''}`}>
                        <NavItem name={item.name} icon={item.icon} link={item.link} />
                    </div>
                );
            })}

            <Separator />

            <div className="nav-item">
                <NavItem name="Profile" icon={<IoPersonCircleOutline size={30}/>} link="/profile" />
            </div>

        </div>
    )
}

export default Navbar